import { HN_SKJEMA_ERRORCODES_RESOURCES } from 'src/constants/constants';
import { useResources } from 'src/resources';

import type { HNSkjemaErrorCodes } from 'src/types/Resources';

const DEFAULT_ERROR_MESSAGE = 'Det har oppstått en feil. Prøv igjen senere.';

export const useGetErrorMessageFromErrorCode = (errorCode?: string): string | undefined => {
  const errorCodesResources = useResources<HNSkjemaErrorCodes>(HN_SKJEMA_ERRORCODES_RESOURCES);

  if (!errorCode) {
    return undefined;
  }

  if (!errorCodesResources) {
    return DEFAULT_ERROR_MESSAGE;
  }

  const code = errorCode.replace('-', '_').replace(/^./, char => char.toLowerCase()) as keyof HNSkjemaErrorCodes;
  const errorCodeMessage = errorCodesResources[code];

  return errorCodeMessage ?? DEFAULT_ERROR_MESSAGE;
};
